import { render } from "./AyudaMedico.vue?vue&type=template&id=6b86494e&scoped=true"
import script from "./AyudaMedico.vue?vue&type=script&lang=js"
export * from "./AyudaMedico.vue?vue&type=script&lang=js"

import "@/assets/css/ayuda.css?vue&type=style&index=0&id=6b86494e&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b86494e"]])

export default __exports__